import { MiddlewareAPIResponse } from '../../middlewareapiresponse';
import { MiddlewareDtoImpl } from '../../../dto/middlewaredto';
import { BannerDto } from '../../../dto/banner/bannerdto';

export interface BannerResponse extends MiddlewareAPIResponse
{
    getListOfBannerDtos(): BannerDto[];
}

export class BannerResponseDtoImpl extends MiddlewareDtoImpl implements BannerResponse
{
    private bannerDetailsRespnseDtos : BannerDto[];

    getListOfBannerDtos(): BannerDto[]
    {
        return this.bannerDetailsRespnseDtos;
    }
    setBannerDto(bannerDetailsRespnseDtos: BannerDto[])
    {
        this.bannerDetailsRespnseDtos = bannerDetailsRespnseDtos;
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/banner/getbanner/bannerresponse.tsx